import { ChangeEvent } from 'react';
import { ValidationItem } from 'src/types/ViewModel/ValidationItemType';

const validateInput = (value: number, min: string | null, max: string | null, customValidations?: ValidationItem[]): InputValidatorType => {
    if (min && value < +min) {
        return {
            isValid: false,
        };
    }
    if (max && value > +max) {
        return {
            isValid: false,
        };
    }
    return validateCustomValidations(customValidations, value);
};

export const validateCustomValidations = (customValidations?: ValidationItem[], args?: any): InputValidatorType => {
    if (customValidations) {
        const customValidation = customValidations.find((c) => c.validationFunction && c.validationFunction(args));
        if (customValidation) {
            return {
                isValid: false,
                customValidation,
            };
        }
    }

    return {
        isValid: true,
    };
};

export type InputValidatorType = {
    isValid: boolean;
    customValidation?: ValidationItem;
};

export const validateInputFromEvent = (event: ChangeEvent<HTMLInputElement>, customValidations?: ValidationItem[]): InputValidatorType => {
    const min = event.target.min !== '' ? event.target.min : null;
    const max = event.target.max !== '' ? event.target.max : null;
    const value = +event.target.value;

    return validateInput(value, min, max, customValidations);
};

export const validateInputFromProps = (
    min: number | undefined,
    max: number | undefined,
    value: any,
    customValidations?: ValidationItem[]
): InputValidatorType => {
    if (value === null || value === undefined || value === '') {
        return {
            isValid: true,
        };
    }

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (typeof numericValue === 'number' && !isNaN(numericValue)) {
        if (min !== undefined && numericValue < min) {
            return {
                isValid: false,
            };
        }
        if (max !== undefined && numericValue > max) {
            return {
                isValid: false,
            };
        }
    }

    if (customValidations?.length > 0) {
        const customValidation = validateCustomValidations(customValidations, value);
        if (!customValidation.isValid) {
            return customValidation;
        }
    }

    return {
        isValid: true,
    };
};

export const validateTimeInput = (hours: number, min?: number, max?: number): InputValidatorType => {
    if (min && max) return { isValid: hours >= min && hours <= max };
    if (min) return { isValid: hours >= min };
    if (max) return { isValid: hours <= max };
    return { isValid: true };
};

export const validateDateInput = (date: Date, customValidations?: ValidationItem[]): InputValidatorType => {
    return validateCustomValidations(customValidations, date);
};
